import { gql } from '@apollo/client';

export default gql`
  mutation deleteVacation($_id: String) {
    deleteVacation(_id: $_id) {
      ok
      message
      error
    }
  }
`;
